import { render } from "./formcaisse5.vue?vue&type=template&id=bae4a7c0&scoped=true"
import script from "./formcaisse5.vue?vue&type=script&lang=js"
export * from "./formcaisse5.vue?vue&type=script&lang=js"

import "./formcaisse5.vue?vue&type=style&index=0&id=bae4a7c0&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bae4a7c0"]])

export default __exports__